import { RiskMatrixTranslation } from 'app/area/risk-matrix-administration/constants';
import { ComplexValue } from 'app/types-shared';
import React from 'react';
import { LabelSpinner } from 'ui/common/label-spinner/label-spinner';
import styles from './case-types.scss';

interface CaseTypesProps {
  caseTypes: ComplexValue<number>[];
  fetching: boolean;
  translation: RiskMatrixTranslation;
}

export const CaseTypes = ({ caseTypes, translation, fetching }: CaseTypesProps) => {
  if (fetching) {
    return <LabelSpinner />;
  }

  return !caseTypes || caseTypes.length === 0
    ? null
    : <div className={`${styles.label} col-md-12`}>
      {translation.risk_matrix_used_for} {caseTypes.map((caseType, index) => caseType.description || caseType.longDescription
        ? <span key={caseType.value}>
          <span className={styles.labelBold}>"{caseType.description}"</span>
          {caseTypes.length === index + 1 ? '' : ', '}
        </span>
        : '')}
    </div>;
};
